export const VERSION = '09091d2-prod'
